import { networkService } from "../components/config/axios";

export const createElementFromSnapshot = (snapshot) => {
  const { id, created_at, updated_at, docs_element_tags, ...rest } = snapshot || {};
  const payload = {
    ...rest,
    tags: (docs_element_tags || [])
      .map((tag) => {
        const tagId = tag?.tag_id ?? tag?.tag?.id ?? tag?.id;
        return tagId ? { id: tagId } : null;
      })
      .filter(Boolean),
  };
  return networkService("/docs/elements.json", "POST", payload);
};

export const patchElement = (id, payload) =>
  networkService(`/docs/elements/${id}.json`, "PATCH", payload);

export const patchElementFromImageSnapshot = async (id, snapshot = {}) => {
  const token = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  const form = new FormData();
  form.append("_method", "patch");
  form.append("tags", "keep");
  form.append("geometry", JSON.stringify(snapshot.geometry ?? {}));
  if (snapshot.value != null) form.append("value", JSON.stringify(snapshot.value));

  [
    "doc_id", "docs_file_id", "element_type", "page", "order_on_page",
    "transparency", "rotate", "flip", "sec_to_delay", "disappear_after",
    "image_text", "recurrence",
  ].forEach((key) => {
    if (snapshot[key] != null) form.append(key, snapshot[key]);
  });

  if (typeof snapshot.file_url === "string" && snapshot.file_url.startsWith("data:")) {
    const blob = await (await fetch(snapshot.file_url)).blob();
    const ext = (blob.type.split("/")[1] || "jpg").replace("jpeg", "jpg");
    const name = snapshot.file_details?.name || `image.${ext}`;
    form.append("file", new File([blob], name, { type: blob.type }));
  }

  const response = await fetch(`/docs/elements/${id}`, {
    method: "PATCH",
    headers: token ? { "X-CSRF-Token": token } : {},
    body: form,
    credentials: "same-origin",
  });
  if (!response.ok) throw new Error(`Server returned ${response.status}`);
  return { data: await response.json() };
};

// Duplicates `element` server-side (file, tags, rotate/flip all carry over via
// the backend's own record .dup) landing the copy at `geometry`, on `page` when
// given, instead of the source element's page and same-spot offset.
export const duplicateElement = (element, geometry, page) =>
  networkService(`/docs/elements/${element.id}.json`, "PATCH", {
    duplicate: true,
    rotate: element.rotate,
    flip: element.flip,
    doc_id: element.doc_id,
    tags: element.tags || "keep",
    scrolling: element.scrolling,
    ...(page != null ? { page } : {}),
    geometry,
  });

export const deleteElementById = (id) =>
  networkService(`/docs/elements/${id}.json`, "DELETE");

export const restoreElementById = (id) =>
  networkService(`/docs/elements/${id}/restore.json?context=editor`, "PATCH");
